class Module {
  // called during Windmill's ready/enter hook
  init() {}

  // called during Windmill's done hook.
  start() {}

  // called during Windmill's exiting hook.
  stop() {}

  // called during Windmill's exited hook.
  destroy() {}

  // getter - setter
  get name() {
    return null;
  }
}

export default Module;
